import React from 'react';
import SendOutlined from '@material-ui/icons/SendOutlined';

export default function SendOutlinedIcon() {

    return (
        <SendOutlined />
    );
};